import { extendTheme } from "@stardust-ds/react";

const config = {
  color: {
    primary: {
      pure: "#26255E",
      lighter: "#E5F4FF",
      light: "#AFDBFF",
      medium: "#1A71FA",
      dark: "#231F20",
      darker: "#011D33",
      gray: "#E2E2E2",
    },
    secondary: {
      pure: "#1A99FA",
      lighter: "#E5FCFF",
      light: "#AFF4FF",
      medium: "#28A6BA",
      dark: "#026777",
      darker: "#012C33",
      gray: "#5A646E"
    },
    positive: {
      pure: "#00A859",
      light: "#B0E1BD",
      medium: "#1D8D3C",
      dark: "#125A26",
    },
    negative: {
      pure: "#EE4953",
      light: "#FFBEC2",
      medium: "#BE3A42",
      dark: "#7A252A",
      background: '#FAEFF1',
      "background-icons": '#FAE0E3',
    },
    status: {
      positive: "#1ECB4F",
      negative: "#FF3541",
      alert: "#FFAE00",
      neutral: {
        1: "#0066FF",
        2: "#3B454F",
        3: "#B83EE3",
        4: "#00344A",
      },
      "alert-2": "#FF7E35",
      "alert-background-color": "rgba(255, 174, 0, 0.16)",
      "alert-green-background-color": "rgba(30, 203, 79, 0.16)",
      "alert-green": "#1ECB4F"
    },
    text: {
      grey: '#5A646E',
      "grey-8": '#22272D',
      "grey-1": '#F2F5F8'
    },
    icon: {
      disabled: "#1A48FA80"
    },
    billings: {
      red: '#EE4953',
      "red-light": "rgb(238, 73, 83, 0.08)",
      "blue-light": "rgb(26, 72, 250, 0.08)",
      "red-light-hover": "rgb(238, 73, 83, 0.16)",
      "blue-light-hover": "rgb(26, 72, 250, 0.16)",
    },
    input: {
      border: '#E2E2E2'
    },
    icons: '#E9EBEE',
    shadow: {
      max: "0px 4px 8px 0px #00000026;",
      medium: "0px 4px 8px 0px #0000001A;",
      light: "0px 2px 4px 0px #0000001A;"
    }
  },
  media_query: {
    mobile: "580px",
    tablet: "800px",
  },
};

export const theme = extendTheme(config);
